/*
Controller: Accounts

Operations:
  transferAccountDetails
  getAccounts
*/
var Api = require('../config')
var AccountTransferRequestDef = require('../definitions/AccountTransferRequest')

var Accounts = (function () {
  /*
  Operation: transferAccountDetails
  Transfer account detail
  Parameters:
    bodyRequest: Payment object
  Responses:
    HTTP 200: Transfer to SAP success
    HTTP 400: Invalid request
    HTTP 403: Operation not permitted
    HTTP 422: Invalid request
  */
  function transferAccountDetailsAccounts (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        AccountTransferRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/account/transfer'
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getAccounts
  Query existing account
  Parameters:
    userId: Id of the user
  Responses:
    HTTP 200: List of payment Accounts
    HTTP 412: SAP API Connection Issue
    HTTP 424: The requested resource depends on another resource that has failed.
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getAccountsAccounts (userId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/accounts/{userId}'
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['transferAccountDetails'] = transferAccountDetailsAccounts
  ret['getAccounts'] = getAccountsAccounts
  return ret
})()

module.exports = Accounts
